function loadView(view) {
	return () =>
		import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}

export default [
	{
		path: '',
		name: 'TournamentHome',
		component: loadView('Front/Tournament/Divisions')
	},
	{
		path: 'teams',
		name: 'TournamentTeams',
		component: loadView('Front/Tournament/Teams')
	},
	{
		path: 'transfers',
		name: 'TournamentTransfers',
		component: loadView('Front/Tournament/Transfers')
	},
	{
		path: 'movements',
		name: 'TournamentMovements',
		component: loadView('Front/Tournament/Movements')
	},
	{
		path: 'the-bests',
		name: 'TournamentBests',
		component: loadView('Front/Tournament/TheBests')
	},
	{
		path: 'gks',
		name: 'TournamentBestGks',
		component: loadView('Front/Tournament/Gks')
	},
	{
		path: 'assists',
		name: 'TournamentBestAssists',
		component: loadView('Front/Tournament/Assists')
	},
	{
		path: 'scorers',
		name: 'TournamentBestScorers',
		component: loadView('Front/Tournament/Scorers')
	},
	{
		path: 'mvp',
		name: 'TournamentBestMvps',
		component: loadView('Front/Tournament/Mvps')
	},
	{
		path: 'ranking-players',
		name: 'TournamentRankinglayers',
		component: loadView('Front/Tournament/RankingPlayers')
	},
	{
		path: 'ranking-teams',
		name: 'TournamentRankingTeams',
		component: loadView('Front/Tournament/RankingTeams')
	},
	{
		path: 'signings',
		name: 'TournamentSignings',
		component: loadView('Front/Tournament/Signings')
	},
	{
		path: 'signings/sell-players/team/:teamSlug',
		name: 'TournamentSellPlayers',
		component: loadView('Front/Tournament/SellPlayers')
	},
	{
		path: 'rules',
		name: 'TournamentRules',
		component: loadView('Front/Tournament/Rules')
	},
	{
		path: 'banned',
		name: 'TournamentBanned',
		component: loadView('Front/Tournament/Banned')
	},
	{
		path: 'notices/:noticeSlug',
		name: 'TournamentNotice',
		component: loadView('Front/Tournament/Notice')
	},
	{
		path: 'champions',
		name: 'Champions',
		component: loadView('Front/Tournament/Champions')
	}
]
